const COUNTRY_FLAGS = {
  afghanistan: "🇦🇫",
  albania: "🇦🇱",
  algeria: "🇩🇿",
  argentina: "🇦🇷",
  armenia: "🇦🇲",
  australia: "🇦🇺",
  austria: "🇦🇹",
  azerbaijan: "🇦🇿",
  bahrain: "🇧🇭",
  bangladesh: "🇧🇩",
  belarus: "🇧🇾",
  belgium: "🇧🇪",
  bolivia: "🇧🇴",
  "bosnia and herzegovina": "🇧🇦",
  brazil: "🇧🇷",
  brunei: "🇧🇳",
  bulgaria: "🇧🇬",
  cambodia: "🇰🇭",
  cameroon: "🇨🇲",
  canada: "🇨🇦",
  chile: "🇨🇱",
  china: "🇨🇳",
  colombia: "🇨🇴",
  "costa rica": "🇨🇷",
  croatia: "🇭🇷",
  cuba: "🇨🇺",
  cyprus: "🇨🇾",
  "czech republic": "🇨🇿",
  czechia: "🇨🇿",
  denmark: "🇩🇰",
  "dominican republic": "🇩🇴",
  ecuador: "🇪🇨",
  egypt: "🇪🇬",
  "el salvador": "🇸🇻",
  estonia: "🇪🇪",
  ethiopia: "🇪🇹",
  finland: "🇫🇮",
  france: "🇫🇷",
  georgia: "🇬🇪",
  germany: "🇩🇪",
  ghana: "🇬🇭",
  greece: "🇬🇷",
  guatemala: "🇬🇹",
  honduras: "🇭🇳",
  "hong kong": "🇭🇰",
  hungary: "🇭🇺",
  iceland: "🇮🇸",
  india: "🇮🇳",
  indonesia: "🇮🇩",
  iran: "🇮🇷",
  "iran, islamic republic of": "🇮🇷",
  iraq: "🇮🇶",
  ireland: "🇮🇪",
  israel: "🇮🇱",
  italy: "🇮🇹",
  "ivory coast": "🇨🇮",
  jamaica: "🇯🇲",
  japan: "🇯🇵",
  jordan: "🇯🇴",
  kazakhstan: "🇰🇿",
  kenya: "🇰🇪",
  "korea, democratic people's republic of": "🇰🇵",
  "korea, republic of": "🇰🇷",
  "north korea": "🇰🇵",
  "south korea": "🇰🇷",
  kosovo: "🇽🇰",
  kuwait: "🇰🇼",
  kyrgyzstan: "🇰🇬",
  laos: "🇱🇦",
  latvia: "🇱🇻",
  lebanon: "🇱🇧",
  libya: "🇱🇾",
  lithuania: "🇱🇹",
  luxembourg: "🇱🇺",
  macao: "🇲🇴",
  malaysia: "🇲🇾",
  maldives: "🇲🇻",
  mali: "🇲🇱",
  malta: "🇲🇹",
  mexico: "🇲🇽",
  moldova: "🇲🇩",
  mongolia: "🇲🇳",
  montenegro: "🇲🇪",
  morocco: "🇲🇦",
  mozambique: "🇲🇿",
  myanmar: "🇲🇲",
  namibia: "🇳🇦",
  nepal: "🇳🇵",
  netherlands: "🇳🇱",
  "new zealand": "🇳🇿",
  nicaragua: "🇳🇮",
  nigeria: "🇳🇬",
  norway: "🇳🇴",
  oman: "🇴🇲",
  pakistan: "🇵🇰",
  palestine: "🇵🇸",
  panama: "🇵🇦",
  paraguay: "🇵🇾",
  peru: "🇵🇪",
  philippines: "🇵🇭",
  poland: "🇵🇱",
  portugal: "🇵🇹",
  qatar: "🇶🇦",
  romania: "🇷🇴",
  russia: "🇷🇺",
  "russian federation": "🇷🇺",
  rwanda: "🇷🇼",
  "saudi arabia": "🇸🇦",
  senegal: "🇸🇳",
  serbia: "🇷🇸",
  singapore: "🇸🇬",
  slovakia: "🇸🇰",
  slovenia: "🇸🇮",
  somalia: "🇸🇴",
  "south africa": "🇿🇦",
  spain: "🇪🇸",
  "sri lanka": "🇱🇰",
  sudan: "🇸🇩",
  sweden: "🇸🇪",
  switzerland: "🇨🇭",
  syria: "🇸🇾",
  "syrian arab republic": "🇸🇾",
  taiwan: "🇹🇼",
  tajikistan: "🇹🇯",
  tanzania: "🇹🇿",
  thailand: "🇹🇭",
  tunisia: "🇹🇳",
  turkey: "🇹🇷",
  turkmenistan: "🇹🇲",
  uganda: "🇺🇬",
  ukraine: "🇺🇦",
  "united arab emirates": "🇦🇪",
  uae: "🇦🇪",
  "united kingdom": "🇬🇧",
  uk: "🇬🇧",
  "united states": "🇺🇸",
  "united states of america": "🇺🇸",
  usa: "🇺🇸",
  uruguay: "🇺🇾",
  uzbekistan: "🇺🇿",
  venezuela: "🇻🇪",
  vietnam: "🇻🇳",
  "viet nam": "🇻🇳",
  yemen: "🇾🇪",
  zambia: "🇿🇲",
  zimbabwe: "🇿🇼",
};

export const getCountryFlag = (countryName) => {
  if (!countryName) return null;
  return COUNTRY_FLAGS[countryName.toLowerCase().trim()] || null;
};
